{
  "Accessibility menu": "Menu ng Accessibility",
  "Reset settings": "I-reset ang mga setting",
  "Close": "Isara",
  "Content adjustments": "Ayusin ang Nilalaman",
  "Navigation adjustments": "Ayusin ang Pag-navigate",
  "Align Left": "I-align sa Kaliwa",
  "Adjust Font Size": "I-adjust ang Laki ng Font",
  "Highlight Title": "I-highlight ang Pamagat",
  "Highlight Links": "I-highlight ang mga Link",
  "Readable Font": "Madaling Basahing Font",
  "Colour adjustments": "Ayusin ang Kulay",
  "Dark Contrast": "Madilim na Pagkakaiba",
  "Light Contrast": "Maliwanag na Pagkakaiba",
  "High Contrast": "Mataas na Pagkakaiba",
  "High Saturation": "Mataas na Saturation",
  "Low Saturation": "Mababang Saturation",
  "Monochrome": "Monokrom",
  "Tools": "Mga Kasangkapan",
  "Reading Guide": "Gabay sa Pagbabasa",
  "Stop Animations": "Itigil ang Mga Animasyon",
  "Big Cursor": "Malaking Cursor",
  "Increase Font Size": "Palakihin ang Laki ng Font",
  "Decrease Font Size": "Bawasan ang Laki ng Font",
  "Letter Spacing": "Espasyo ng mga Titik",
  "Line Height": "Taas ng Linya",
  "Font Weight": "Bigat ng Font",
  "Dyslexia Font": "Font para sa Dyslexia",
  "Language": "Wika",
  "Accessibility widget": "Buksan ang Menu ng Accessibility",
  "Accessibility Profiles": "Mga Profile ng Accessibility",
  "Cognitive Disability": "Kapansanan sa Kognitibo",
  "Seizure Safe": "Ligtas sa Seizure",
  "Accessibility statement": "Pahayag ng Accessibility"
}
